'use strict';
import {module} from '../app';

module.controller('DemoCtrl', [
    '$scope', '$location', '$http', 'authService', '$ionicLoading', 'modalService', 'localStorage', function ($scope, $location, $http, authService, $ionicLoading, modalService, localStorage) {

      $scope.createExam = function () {
        $ionicLoading.show({
          template: 'Loading...'
        });
        $http.post(authService.currentMagViewUrl() + '/api/worklist/generateTestRecord').then($ionicLoading.hide, $ionicLoading.hide);
      };
      $scope.insertDemoData = function () {
        $ionicLoading.show({
          template: 'Loading...'
        });
        $http.post(authService.currentMagViewUrl() + '/api/worklist/generateDemoData').then($ionicLoading.hide, $ionicLoading.hide);
      };
      $scope.deleteAllWorklists = function () {
        modalService.showConfirmation(function () {
          $ionicLoading.show({
            template: 'Loading...'
          });
          $http.post(authService.currentMagViewUrl() + '/api/worklist/deleteAllWorklists').then($ionicLoading.hide, $ionicLoading.hide);
        }, "Are you sure you want clean up all studies ? (ALL RECORDS WILL BE DELETED)");
      };
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/controllers/demo.js